import { render, staticRenderFns } from "./EditpasswordemployeePage.vue?vue&type=template&id=7fdd418e"
import script from "./EditpasswordemployeePage.vue?vue&type=script&lang=js"
export * from "./EditpasswordemployeePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports